export default __webpack_public_path__ + "441cb22eea6ea32909126b9eec3e256f.jpg";